<template>
  <main>
    <h1 class="side-title"><span class="color-primary">Melanie's</span> Route<br>
      <!-- <small v-if="fragUrsContent.length">von {{ fragUrsContent[0].locations[0].fields.title }} nach {{ fragUrsContent[0].locations[1].fields.title }}</small> -->
    </h1>
    <div class="routenPreviewContainer container">
      <RoutePreview v-for="route in fragUrsContent" v-bind:key="route.id" :route="route"></RoutePreview>
    </div>
    <!-- <textarea>{{ fragUrsContent }}</textarea> -->
  </main>
</template>

<script>

import RoutePreview from '@/components/RoutePreview.vue';
import { contentfulEnvironment } from '../js/contentful';
import { contentfulEntries } from '../js/entries';

export default {
  name: 'home',
  components: {
    RoutePreview,
  },
  data() {
    return {
      fragUrsContent: [],
      publicPath: process.env.BASE_URL,
    };
  },
  async mounted() {
    /**
     * Contentful
     */
    const useContentful = false;
    let entries;
    if (useContentful) {
      console.log('from contentful');
      const env = await contentfulEnvironment;
      entries = await env.getEntries({
        content_type: 'route',
        resolveLinks: true,
        include: 10,
      });
    } else {
      entries = contentfulEntries;
    }

    // console.log(entries.items);

    // put field in array
    const items = entries.items.map((value, index, array) => {
      return value.fields;
    });

    // sort array
    items.sort((a, b) => a.id - b.id);

    // save array to data
    this.fragUrsContent = items;
    // console.log(items);
  },
};
</script>

<style lang="scss">
.routenPreviewContainer{
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}
</style>
